import facebook from '../../../assets/img/icon-facebook.png';
import telegram from '../../../assets/img/icon-telegram.png';
import twitter from '../../../assets/img/ico-twitter.svg';
import zap from '../../../assets/img/ico-zap.svg';
import print from '../../../assets/img/midias/print.svg';
import { useLocation } from "react-router-dom"
// import "../../../assets/css/dist/historia.dist.css";

const PageDescriptionFootnote = (props: any) => {
    const { pathname } = useLocation();
    const completeUrl = `https://institucional.forluz.org.br${pathname}`;
    const completeUrlFormatted = completeUrl.replace("...=&", "?");
    const noticiaTitle = props.title;
    const foo = () => {
        window.print();
        return false;
    }
    return (
        <div>
            <ul className="list-unstyled d-flex align-items-center justify-content-end w-100">
                <li className="mr-3 d-none d-lg-block" onClick={foo}>
                    <a href="#">
                        <img src={print} alt="Imprimir" />
                    </a>
                </li>
               
                <li className="mr-3"> 
                    <a href={"https://www.facebook.com/sharer.php?u=" + completeUrlFormatted} target="_blank" rel="noopener noreferrer">
                            <img src={facebook} alt="facebook"/>
                    </a>
                </li>
              
                <li className="mr-3"> 
                    <a href={noticiaTitle? "https://twitter.com/intent/tweet?text=" + noticiaTitle + " - " + completeUrlFormatted :
                        "https://twitter.com/intent/tweet?text=" + completeUrlFormatted} target="_blank" rel="noopener noreferrer">
                            <img src={twitter} alt="twitter"/>
                    </a>
                </li>
                <li className="mr-3"> 
                    <a href={noticiaTitle? "whatsapp://send?text=" + noticiaTitle + " - " + completeUrlFormatted :
                        "whatsapp://send?text=" + completeUrlFormatted} target="_blank" rel="noopener noreferrer"><img src={zap} alt="whatsapp"/>
                    </a>
                </li>
                <li className="mr-3"> 
                    <a href={noticiaTitle? "https://t.me/share/url?url="+ completeUrlFormatted + "&text=" + noticiaTitle:
                        "https://t.me/share/url?url="+ completeUrlFormatted} target="_blank" rel="noopener noreferrer"><img src={telegram} alt="telegram"/>
                    </a>
                </li>
            </ul>
        </div>
    )
};
export default PageDescriptionFootnote;
